import { Middleware } from '@reduxjs/toolkit';
import { setUser, User } from '@tsl-frontend/tsl-keycloak-auth';
import {
    addGlobalContext,
    customUserAction,
    groupTracking,
    pageChange,
} from '../actions';
import { RudderStackAnalyticsType } from '../services';

/**
 * We use semantic versioning for events, starting at 1.0.0.
 * The major version should be increased for breaking changes - renaming, removing etc.
 * The minor version should be used for basically anything else.
 */

const createUserObject = (user: User) => {
    const { platform_user_id } = user;

    return {
        userId: `${platform_user_id}`,
    };
};

export const Rudderstack = (
    rudderAnalytics: RudderStackAnalyticsType,
    trackedEvents: string[],
    extraActionTypes: string[] = [],
): Middleware => {
    return (storeAPI) => {
        return (next) => {
            return (action: any) => {
                if (action.type === setUser.type) {
                    rudderAnalytics.reset();

                    const user = action.payload.user;
                    rudderAnalytics.identify(createUserObject(user));

                    const userRole =
                        user.memberships[0] && user.memberships[0].m_type;

                    rudderAnalytics.setContext('userRole', userRole);
                }

                if (action.type === pageChange.toString()) {
                    const { path } = action.payload;
                    rudderAnalytics.page(path);
                }

                if (action.type === addGlobalContext.toString()) {
                    const { key, value } = action.payload;
                    rudderAnalytics.setContext(key, value);
                }

                if (action.type === customUserAction.toString()) {
                    const { name, extraInfo } = action.payload;
                    if (trackedEvents.includes(name)) {
                        rudderAnalytics.track(name, extraInfo);
                    }
                }

                if (action.type === groupTracking.toString()) {
                    const { schoolId } = action.payload;
                    rudderAnalytics.group(schoolId);
                }

                if (extraActionTypes.includes(action.type)) {
                    rudderAnalytics.track(action.type, action.payload);
                }

                return next(action);
            };
        };
    };
};
